import React, { Component } from 'react'
import SaveAndNavigate from './SaveAndNavigate';
import * as Constants from './CommonConstants';

export default class BaseMainPageLayout extends Component {
    

    render(){
        return (
            <div className="main-container">
                <div className="nav-section">

                    <div className="nav-section-for-collapse">
                        <div className="navbar-brand">Welcome to the PCRB/DCRB
                            <br/>
                            Correspondence Manager
                        </div>                            
                        <div>{this.renderLoginMessage()}</div>
                    </div>
                    { (this.state.formState === Constants.EDIT_MODE || this.state.formState === Constants.READ_ONLY_MODE) &&    
                        this.renderSaveAndNavigate()
                    }

                </div>
                <div className="user-home-page-content">
                        {this.renderContentArea()}
                </div>
                    
            </div>
        )        
    }

    renderSaveAndNavigate=()=>{
        return(
            <SaveAndNavigate  
            readOnlyMode = {(this.state.formState===Constants.READ_ONLY_MODE)}
            navigateAway={(saveResult) => this.navigateAway(saveResult)} 
            getDataHandler={this.questionnaireRef}
            cancelText={this.cancelText()}/>
        )
    }

    cancelText=()=>"";
}
